import { TableCell, TableHead, TableRow } from '@mui/material';

export const CustomTableHeader = () => {
    return (
        <TableHead>
            <TableRow>
                <TableCell>Name</TableCell>
                <TableCell align='right'>Last Name</TableCell>
                <TableCell align='right'>Email</TableCell>
                <TableCell align='right'>Type</TableCell>
                <TableCell align='right'>Active</TableCell>
                <TableCell align='right'>Super User</TableCell>
                <TableCell></TableCell>
            </TableRow>
        </TableHead>
    );
};
